import { render, staticRenderFns } from "./TariffOrder.vue?vue&type=template&id=5ee42b3d&scoped=true&"
import script from "./TariffOrder.vue?vue&type=script&lang=js&"
export * from "./TariffOrder.vue?vue&type=script&lang=js&"
import style0 from "./TariffOrder.vue?vue&type=style&index=0&id=5ee42b3d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ee42b3d",
  null
  
)

export default component.exports